import * as React from "react";
import { Stack } from "@mui/material";
import { StatusCard } from "@/components/dashboard/StatusCard";
import { MetricCard } from "@/components/dashboard/MetricCard";
import { QueryStateBoundary } from "@/components/dashboard/QueryStateBoundary";
import { useBrokerList } from "@/hooks/queries/useBrokerStatus";

interface BrokerSummary {
  name: string;
}

/** Reuses Sprint 3.2's `useBrokerList` hook rather than duplicating it. */
export function AnalyticsSystemInformationSection(): React.JSX.Element {
  const brokersQuery = useBrokerList();

  return (
    <StatusCard title="System Information">
      <Stack spacing={1.5}>
        {/* AnalyticsResponseDto carries no distinct version or calculation timestamp field. */}
        <MetricCard label="Analytics Version" value={null} />
        <MetricCard label="Calculation Timestamp" value={null} />
        <QueryStateBoundary
          query={brokersQuery}
          isEmpty={(data) => (data as unknown as BrokerSummary[]).length === 0}
          emptyMessage="No broker providers are configured."
        >
          {(payload) => (
            <MetricCard
              label="Provider"
              value={(payload as unknown as BrokerSummary[]).map((b) => b.name).join(", ")}
            />
          )}
        </QueryStateBoundary>
      </Stack>
    </StatusCard>
  );
}
